import { render, staticRenderFns } from "./CheckPermission.vue?vue&type=template&id=7842d21e&"
import script from "./CheckPermission.vue?vue&type=script&lang=js&"
export * from "./CheckPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports